<app-choice [data]="data" (output)="dialogRef.close($event)"></app-choice>
